import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { SideMenu, BackHeader } from "./../../components";
import { Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { FileUploader } from "react-drag-drop-files";
const fileTypes = ["JPEG", "PNG", "GIF"];
const ResultEdit = () => {
  const navigate = useNavigate();
  const [file, setFile] = React.useState(null);
  const handleChange = (file) => {
    setFile(file);
  };
  return (
    <SideMenu>
      <div className="page-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <p className="page-form-heading">edit result</p>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
              <div>
                <FileUploader
                  multiple={true}
                  handleChange={handleChange}
                  name="file"
                  types={fileTypes}
                  color="red"
                />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={12} sm={12} xs={12}></Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <p className="input-heading">Remarks</p>
              <textarea
                className="textarea"
                placeholder="Enter your Remarks"
                rows="20"
                cols="40"
              ></textarea>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <Button
                className="form-button"
                variant="text"
                onClick={() => navigate("/tutor-panel/result")}
              >
                Submit to the student
              </Button>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
          </Grid>
        </Box>
      </div>
    </SideMenu>
  );
};
export default ResultEdit;
